export { default, type ProgramSectionProps } from './ProgramSection';
